import AjaxPageLinkManager from "./AjaxPageLinkManager";
import {default as AjaxPage, LoadState} from "./AjaxPage";

export default AjaxPage;
export {AjaxPageLinkManager, LoadState};